import { createFileRoute } from "@tanstack/react-router";

// Route metadata only. Component lives in `$clientId.lazy.tsx`.
export const Route = createFileRoute("/admin/clients/$clientId")({});
